import React from 'react'
import { RecentlyOpenedEntity, ResultObjectType } from '@cbgms/api'
import { RecentlyOpenedWorkOrder } from './RecentlyOpenedWorkOrder'
import { RecentlyOpenedInvoice } from './RecentlyOpenedInvoice'
import { useSearchResultTypeContext } from '../../../context/SearchResultTypeContext'
import { VehicleResult } from '../../../search-v2/ResultsV2/VehicleResult'

interface RecentlyOpenedResultType {
  entity: RecentlyOpenedEntity
  hasGroupHeader: boolean
  primaryAction?: () => Promise<void>
}

export const RecentlyOpenedResult: React.FC<RecentlyOpenedResultType> = props => {
  const { entity, hasGroupHeader, primaryAction } = props
  const { Workorder, Order, WorkorderInvoice, Vehicle } = entity

  const { isPortal } = useSearchResultTypeContext()

  return (
    <>
      {Workorder && (
        <RecentlyOpenedWorkOrder
          hasGroupHeader={hasGroupHeader}
          resultType={ResultObjectType.WorkOrder}
          workOrder={Workorder}
          data-testid='select-recently-opened'
        />
      )}
      {Order && (
        <RecentlyOpenedWorkOrder
          hasGroupHeader={hasGroupHeader}
          resultType={ResultObjectType.Order}
          workOrder={Order}
          data-testid='select-recently-opened-order'
        />
      )}
      {!isPortal && WorkorderInvoice && <RecentlyOpenedInvoice hasGroupHeader={false} invoice={WorkorderInvoice} />}
      {isPortal && Vehicle && (
        <VehicleResult
          Vehicle={{
            Key: Vehicle.VehicleUUID,
            Values: [Vehicle] as any
          }}
          Type={ResultObjectType.DatabaseVehicle}
          hasGroupHeader
          primaryAction={primaryAction}
          selected={false}
          clearQuery={() => {}}
        />
      )}
    </>
  )
}
